import BaseAPI from "../baseApi";
import UsersResponce from "../models/usersResponce";
import ScansResponce from "../models/scansResponce";
import ObjUrlResponce from "../models/objUrlResponce";

export default class SharesService extends BaseAPI {
  protected baseUrl(): string {
    return super.baseUrl() + "/shares";
  }

  public async users(): Promise<UsersResponce | null> {
    let responce = await this.request(this.baseUrl() + "/users", {
      method: "GET"
    });
    if (responce.code != 200) {
      return null;
    }
    let content = responce.content;
    if (content == "") {
      return null;
    }
    return JSON.parse(content);
  }

  public async scans(userIds: number[]): Promise<ScansResponce | null> {
    let responce = await this.request(
      this.baseUrl() + "/scans?user_ids=" + userIds.join(","),
      {
        method: "GET"
      }
    );
    if (responce.code != 200) {
      return null;
    }
    let content = responce.content;
    if (content == "") {
      return null;
    }
    return JSON.parse(content);
  }

  public async objUrl(scanId: number): Promise<ObjUrlResponce> {
    let responce = await this.request(
      this.baseUrl() + "/scans/" + scanId + "/obj-url",
      {
        method: "GET"
      }
    );
    return JSON.parse(responce.content);
  }

  public async csv(scanId: number): Promise<string> {
    let responce = await this.request(
      this.baseUrl() + "/scans/" + scanId + "/csv",
      {
        method: "GET"
      }
    );
    return (responce.content);
  }
}
